
<template>
  <!--社区身份证-->
  <div>
    <x-tabula
      ref="table"
      :dataSource="dataSource"
      rowKey="passId"
      :searchList="searchList"
      :columns="columns"
      :tableOptList="tableOptList"
      :rowOptList="rowOptList"
      :searchParams.sync="searchParams"
      :listApi="listApi"
      :rowSelection="false"
      @resetSearch = "resetSearch"
    >
      <template slot="opt_t" slot-scope="{row}">
        <a-button @click="toDetail(row.memberId)" type="link">{{row.mobilePhone}}</a-button>
      </template>
    </x-tabula>
  </div>
</template>

<script>
import { fetchSelect } from '../../utils/mixins';
export default {
  mixins: [fetchSelect],
  name: 'passport',
  data () {
    return {
      searchList: [
        { props: ['communityId'], placeholder: '小区', options: [], inputType: 'select', fetchOptions: this.getOptions},
        { props: ['mobilePhone'], placeholder: '手机号', options: [], inputType: 'input' },
        { props: ['status'], placeholder: '状态', options: this.$store.state.statusList, inputType: 'select' },
        { props: ['createDate'], placeholder: ['创建时间', '创建时间'], options: [], inputType: 'datePick' },
        {
          props: ['areas'],
          placeholder: '省市',
          options: [],
          inputType: 'cascader',
          changeOnSelect: true,
          expandTrigger: 'click',
          loadData: e => {
            this.regionSelect(4, 'searchList', '1,2,3', e);
          }
        },
        { props: ['propertyId'], placeholder: '物业', options: [], inputType: 'select' }
      ],
      tableOptList: [],
      rowOptList: [
        { text: '', customRender: true, handle: (row) => this.triggerStatus(row), permi: ['community:passes:editstatus'] }
      ],
      columns: [
        { title: '手机号', dataIndex: 'mobilePhone', align: 'left', width: '', scopedSlots: {customRender: 't'} },
        { title: '小区', dataIndex: 'communityName', align: 'left', width: '' },
        { title: '添加时间', dataIndex: 'createTime', align: 'left', width: '' },
        { title: '状态', dataIndex: 'statusDesc', align: 'left', width: '' },
        { title: '操作', dataIndex: 'action', align: 'left', width: '', scopedSlots: {customRender: 'action'} }
      ],
      dataSource: [],
      searchParams: {
        communityId: undefined,
        mobilePhone: undefined,
        status: undefined,
        createDate: undefined,
        areas: undefined,
        propertyId: undefined
      },
      listApi: {
        url: '/passes/list',
        resHandle: this.resHandle, // this.resHandle
        searchHandle: '' // searchHandle
      }
    };
  },
  mounted () {
    this.getSelect();
  },
  methods: {
    resetSearch () {
      this.communitySelectByStep(undefined, undefined, 'searchList', '0');
      this.searchList[0].searchValue = undefined;
    },
    getOptions (pageNum, search) {
      return this.communitySelectByStep(pageNum, search, 'searchList', '0');
    },
    /* 获取下拉 */
    getSelect () {
      this.propertySelect(5);
      // this.communitySelect(0, 'searchList', 1);
      this.communitySelectByStep(1, undefined, 'searchList', '0');
      this.regionSelect(4);
    },
    /* 查看会员详情 */
    toDetail (id) {
      this.$router.push({
        name: 'memberDetail',
        query: { id: id, ...this.breadParam(this) }
      });
    },
    /* 切换通行证状态 */
    triggerStatus (row) {
      this.$put({
        url: `/passes/changeStatus/${row.passId}`,
        params: { status: row.status === 1 ? 0 : 1 }
      }).then((res) => {
        this.$message.success('状态切换成功！');
        this.$refs.table.getTableList();
      });
    },
    resHandle (res) {
      res.forEach((el) => {
        el.communityName = `${el.area} ${el.communityName}`;
      });
      return res;
    },
    searchHandle (selectData) {
      return selectData;
    }
  }
};
</script>
